<template>
  <div :id="$route.name" class="app">
    <site-menu v-bind:useAutoHideForMobile='true' />
    <site-header />
    <div class="wrapper">
      <background />
      <transition name="fade" mode="out-in">
        <router-view class="routerView" />
      </transition>
    </div>
    <site-footer />
  </div>
</template>

<script>
import Background from './components/Background'
import SiteHeader from './components/SiteHeader'
import SiteFooter from './components/SiteFooter'
import SiteMenu from './components/SiteMenu'
export default {
  name: 'App',
  components: { Background, SiteHeader, SiteFooter, SiteMenu }
}
</script>

<style lang="scss">
@import "./styles/global.scss";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.wrapper {
  margin:0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-left: $MenuWidth;
  transition: .14s ease-out;
  @media (max-width: $MobileWidth) {
    margin-left: 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .12s ease-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue